<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->

    <Banner
      title="Activity"
      subtitle="Activity"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />
    <!-- //서브상단영역 -->

    <BoardNavbar />

    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">데이터 사이언스 체험 활동</h1>
        <!-- //서브 타이틀영역 -->

        <div class="menu-A-read-wrap">
          <div>
            <ul class="line line4">
              <li>데이터 사이언스 체험 프로젝트</li>
              <li>
                <dl class="line2">
                  <dt>제목</dt>
                  <dd>인간행동을 측정·분석·예측하다!</dd>
                </dl>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                <figure>
                  <n-space justify="center">
                    <img src="@/assets/img/career_p_m.jpg" alt="" />
                  </n-space>
                </figure>
              </li>
              <li>
                <dl>
                  <dt>목적</dt>
                  <dd>
                    개인의 다중재능검사 개발 활동을 통해 자신의 재능 전반에 대한
                    이해와 진로 탐색은 물론,<br />
                    인간행동을 측정, 예측하는 ‘데이터 사이언스’ 전문가의 역량 및
                    하는 일을 체험하는 기회를 제공한다.
                  </dd>
                </dl>

                <dl>
                  <dt>목표</dt>
                  <dd>
                    ① 관심 진로 및 직업군을 탐색, 선택하여 주된 일을 파악한다.
                    <br />
                    ② 팀별로, 관심 진로 및 직업군의 행동 특징을 발굴하여 검사를
                    개발한다.
                    <br />
                    ③ 팀별 개발 검사로 진단 실시 후, 범주별 평균을 그래프로
                    제시한다.
                    <br />
                    ④ 팀별 발표로 또래 집단의 다양한 생각을 공유한다.
                  </dd>
                </dl>

                <dl>
                  <dt>대상</dt>
                  <dd>중1 – 중3</dd>
                </dl>

                <dl class="line2">
                  <dt>시간</dt>
                  <dd>3시간</dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line line4">
              <li>팀 과제</li>
              <li>
                <dl class="line2">
                  <dt>재료</dt>
                  <dd>
                    • 자료 1. 직업군 16종 <br />
                    • 자료 2. [활동지 1] 검사 개발 양식<br />
                    • 자료 3. [활동지 2] MY 재능검사 <br />
                    • 자료 4. [활동지 3] 결과리포트 양식
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line">
              <li>
                결과물<br />
                + 결과리포트<br />
                + 직업군 행동 특성
              </li>
              <li>
                <dl class="line2">
                  <dt>구성</dt>
                  <dd>
                    • 모듈 1. [활동 안내] 데이터 사이언스 체험 활동 안내
                    <br />
                    • 모듈 2. [검사 개발] 문항 개발/답지/채점 >> 검사지 개발<br />
                    • 모듈 3. [검사 실시 및 분석] 검사 실시 >> 결과 요약 >>
                    재능지수 및 진로 탐색<br />
                    • 모듈 4. [결과 발표] 검사 소개 >> 검사 결과 소개
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line">
              <li>진행: 관리자</li>
              <li>
                <dl class="line2">
                  <dt>활용</dt>
                  <dd></dd>
                </dl>
              </li>
            </ul>
          </div>

          <div class="btn">
            <router-link :to="`${USER_ROUTES.Product.Activity.Career.Path}`"
              >목록</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.menu-A-read-wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  word-break: keep-all;
  box-sizing: border-box;
}
.menu-A-read-wrap > div h1 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.menu-A-read-wrap > div ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu-A-read-wrap > div ul.box22 {
  padding: 20px 0;
}
.menu-A-read-wrap > div ul li {
  width: 100%;
  font-size: 14px;
  line-height: 1.7em;
}

.menu-A-read-wrap > div ul li:nth-child(1) {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
}
.menu-A-read-wrap > div ul li dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 22px 0;
  border-bottom: 1px solid #ddd;
}

.menu-A-read-wrap > div ul li dl dt {
  width: 100%;
  margin-bottom: 10px;
}
.menu-A-read-wrap > div ul li dl dd {
  line-height: 1.7em;
  width: 100%;
}

.menu-A-read-wrap div.btn {
  margin-top: 50px;
  text-align: center;
}
.menu-A-read-wrap div.btn a {
  display: inline-block;
  text-align: center;
  font-size: 15px;
  background: #fff;
  color: #004e31;
  padding: 5px 25px;
  transition: all 0.2s;
  border: 1px solid #004e31;
  font-weight: 500;
}

@media (min-width: 768px) {
  .menu-A-read-wrap > div ul li dl {
    align-items: center;
  }
  .menu-A-read-wrap > div ul li dl.line3 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul.line {
    border-bottom: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li dl.line2 {
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul.line4 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 180px;
    padding: 0;
    text-align: center;
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 200px);
  }
  .menu-A-read-wrap > div ul li {
    font-size: 15px;
  }
  .menu-A-read-wrap > div ul li dl dt {
    width: 80px;
    margin-bottom: 0;
  }
  .menu-A-read-wrap > div ul li dl dd {
    line-height: 1.7em;
    width: calc(100% - 90px);
  }
}

@media screen and (min-width: 1100px) {
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 270px;
    padding: 0;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 320px);
  }
}
</style>
